import { Calculator as CalcIcon, ArrowRight, ExternalLink } from "lucide-react";
import Reveal from "./Reveal";
import { scrollToId } from "@/lib/lenis";

const IMG = "/assets/petr.jpg";

export default function KabumPro() {
  return (
    <section id="kabum-pro" data-testid="kabum-section" className="py-24 lg:py-32 bg-ink relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <div className="flex items-center gap-4 mb-4">
            <img
              src="/assets/kabum-logo.png"
              alt="KABUM PRO — kalkulačka stavebních materiálů"
              className="h-14 w-14"
              data-testid="kabum-logo"
            />
            <p className="text-xs font-mono tracking-[0.3em] uppercase text-gold/70">
              Inovace KABUM PRO · Konec plýtvání materiálem
            </p>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-zinc-100 leading-tight">
            Platíte jen to, co <span className="gold-text">skutečně zabudujeme</span>
          </h2>
          <p className="mt-6 text-zinc-400 leading-relaxed">
            Jako zakladateli <span className="text-gold-light font-semibold">RESTART PRO</span> mi
            dlouhodobě vadilo zbytečné vyhazování stavebního materiálu a peněz klientů. Proto jsem přímo z praxe na stavbě vyvinul a neustále
            zdokonaluji vlastní AI kalkulačku KABUM PRO — nástroj vytvořený řemeslníkem pro
            řemeslníky.
          </p>
          <p className="mt-4 text-zinc-400 leading-relaxed">
            Materiál tak počítáme na milimetry přesně, eliminujeme prořezy a šetříme vaše peníze
            hned při nákupu. Aplikace je navíc online k dispozici komukoliv, takže si i vy jako
            nezávislý klient můžete orientačně (plus mínus) spočítat, kolik materiálu budete na
            svůj projekt potřebovat.
          </p>
          <p className="mt-6 font-sans font-medium text-base text-gold-light" data-testid="kabum-signature">
            — Petr Lehnert, zakladatel RESTART PRO
          </p>
          <div className="mt-9 flex flex-wrap gap-4">
            <a
              href="https://kabumpro.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="kabum-cta"
              className="inline-flex items-center gap-2 bg-gold text-black font-semibold rounded-full px-6 py-3 hover:bg-gold-light transition-colors"
            >
              <CalcIcon size={17} /> Spočítat materiál na kabumpro.com <ExternalLink size={15} />
            </a>
            <button
              onClick={() => scrollToId("kalkulacka")}
              data-testid="kabum-cta-price"
              className="inline-flex items-center gap-2 border border-white/20 text-zinc-200 rounded-full px-6 py-3 hover:border-gold/60 hover:text-gold transition-colors"
            >
              Odhad ceny stavby <ArrowRight size={15} />
            </button>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative">
            <div className="absolute -inset-3 border border-gold/25 pointer-events-none" />
            <img
              src={IMG}
              alt="Petr Lehnert — zakladatel RESTART PRO a autor kalkulačky KABUM PRO"
              className="w-full aspect-[4/5] object-cover"
            />
          </div>
          <div
            className="mt-8 grid grid-cols-3 gap-3 bg-black/85 backdrop-blur-md border border-gold/25 p-5 font-mono text-xs text-zinc-300"
            data-testid="kabum-stats"
          >
            <p>
              <span className="text-gold block text-base font-semibold">±2 %</span> přesnost
              výpočtu materiálu
            </p>
            <p>
              <span className="text-gold block text-base font-semibold">0 Kč</span> zbytečné
              prořezy
            </p>
            <p>
              <span className="text-gold block text-base font-semibold">online</span> pro každého
              klienta
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
